import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';
import { NgPaymentService } from '../../../services/payment.service';
import { Card } from '../../../interfaces/payment';
import { ModalCoreComponent } from '../../modal-core/modal.component';

@Component({
  selector: 'ng-tickets-cards-list',
  styleUrls: ['./cards-list.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section [ngClass]="{'loading': loading}">
      <ng-core-loading *ngIf="loading"></ng-core-loading>

      <div *ngIf="!loading && !error">
        <div class="card-list">
          <h2 class="title-section">Cartões de crédito</h2>

          <div class="list-container">
            <ng-tickets-card-item
                *ngFor="let card of cards"
                [card]="card"
                [isChecked]="card.id === productSale?.card?.id"
                (select)="selectCard($event)"
                (remove)="confirmDeleteCard($event)">
            </ng-tickets-card-item>
          </div>

          <div class="btn-add-card" (click)="selectCard(null); nextStep.emit('add-card')">Adicionar <i class="fa fa-plus"></i></div>
        </div>

        <div class="container-button">
          <button class="btn btn-pink" (click)="selectCard(null); nextStep.emit('card-selection')">
            <i class="fa fa-chevron-left"></i> Voltar</button>
          <button class="btn btn-pink" (click)="nextStep.emit('confirm-cvv')" [disabled]="!productSale?.card?.id">
            Escolher <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <div *ngIf="!loading && error">
        <p>{{error}}</p>
        <div class="container-button">
          <button class="btn btn-pink" (click)="nextStep.emit('product-list')"><i class="fa fa-chevron-left"></i> Voltar</button>
        </div>
      </div>
    </section>

    <ng-core-modal #modal [title]="'Excluir cartão'" [config]="{ignoreBackdropClick: true, initialState: {cardId: productSale.card?.id }}">
      <p>Tem certeza que deseja excluir este cartão da sua conta?</p>

      <div class="container-button">
        <button class="btn btn-pink-contrast" (click)="modal.closeModal()"> Cancelar</button>
        <button class="btn btn-pink" (click)="removeCard(selectedCard)"> Excluir</button>
      </div>
    </ng-core-modal>
  `
})
export class CardsListComponent implements OnInit {

  @Input() productSale: ProductSale;
  @Output() nextStep = new EventEmitter();
  @ViewChild('modal') modal: ModalCoreComponent;

  cards: Card[] = [];
  loading = true;
  error: string = null;
  selectedCard: string;

  constructor(private paymentService: NgPaymentService) {}

  ngOnInit() {
    this.error = null;
    this.getCardList();
  }

  getCardList() {
    this.paymentService.getCards().subscribe(response => {
      this.cards = response.data;
      this.productSale.cardsLength = response.data.length;

      if (response.data.length) {
        this.loading = false;
      } else {
        this.nextStep.emit('add-card');
      }

    }, () => {
      this.error = 'Ocorreu um erro ao recuperar a lista de cartões da sua conta. Por favor tente novamente.';
      this.loading = false;
    });
  }

  confirmDeleteCard(cardId) {
    this.selectedCard = cardId;
    this.modal.openModal();
  }

  removeCard(id) {
    const { card } = this.productSale;
    this.modal.closeModal();
    this.loading = true;
    this.paymentService.deleteCard(id).subscribe(deletedCard => {
      this.cards = this.cards.filter(el => el.id !== deletedCard.id);
      this.loading = false;

      if (card && card.id && card.id === id) {
        this.productSale.card = null;
      }
    }, () => {
      this.error = 'Ocorreu um erro ao tentar excluir este cartão. Por favor tente novamente.';
      this.loading = false;
    });
  }

  selectCard(card) {
    this.productSale.card = card;
  }
}
